import { render, staticRenderFns } from "./prompter.vue?vue&type=template&id=736c93eb&"
import script from "./prompter.vue?vue&type=script&lang=js&"
export * from "./prompter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports